// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../../node_modules/@zxcabs/rtl-css-loader/index.js?dirTagName=body&diff=true!../../../../../../../../../../node_modules/sass-loader/dist/cjs.js??ref--3-2!../../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./customer-info-form.vue?vue&type=style&index=0&id=1b3c87a4&prod&lang=scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("17196ecb", content, true, {});